import { render, staticRenderFns } from "./AcademyDemoTool.vue?vue&type=template&id=abb33b98&scoped=true&"
import script from "./AcademyDemoTool.vue?vue&type=script&lang=js&"
export * from "./AcademyDemoTool.vue?vue&type=script&lang=js&"
import style0 from "./AcademyDemoTool.vue?vue&type=style&index=0&id=abb33b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb33b98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
